// extracted by mini-css-extract-plugin
export default {"container":"Mails_container__tl7qr","input_name":"Mails_input_name__zwHcY","form_input":"Mails_form_input__4wfIv"};